import { Injectable,Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumeral'
})
@Injectable()
export class FormatnumeralPipe implements PipeTransform {
  transform(value: number): string {
    let formattedValue = value.toString();
    
    while (formattedValue.length < 3) {
      formattedValue = '0' + formattedValue;
    }
    return formattedValue.substr(0, 3);
  }
}